import { SceneConfig } from "../lib/types";

/**
 * 集成测试视频：全流水线验证
 *
 * 素材来源（一次性生成，存于 public/）：
 *   - TTS: byted-text-to-speech skill
 *   - 视频: pexels-media skill
 *   - BGM: 待补（Freesound API key 过期，需更新）
 *
 * 覆盖功能：
 *   1. 组件渲染（SmashText, SplitCompare, ImageShow）
 *   2. 预设系统引用
 *   3. 逐场 TTS 配音播放
 *   4. 视频媒体背景播放
 *   5. 总时长计算
 *   6. 多层叠加（layers[]）：图片 + 文字 + 视觉效果同时出现
 *   7. VisualEffect 视觉特效组件（颗粒、频闪、色偏、扫描线、暗角）
 */
export const integrationTestConfig: SceneConfig[] = [
  // ── S00: 恐怖开场（layers 多层叠加演示） ──
  {
    sceneId: "S00",
    durationInFrames: 90,  // ~3s @ 30fps
    layers: [
      {
        component: "ImageShow",
        preset: "zoomIn",
        props: {
          src: "images/pexels-city-night-20716167.jpg",
        },
      },
      {
        component: "SmashText",
        preset: "glitch",
        props: {
          mainText: "暗夜降临",
          subText: "VisualEffect 叠加演示",
          highlight: ["暗夜"],
        },
      },
      {
        component: "VisualEffect",
        preset: "vhsHorror",
      },
    ],
    audio: {
      src: "audio/tts-01.mp3",
    },
  },
  // ── S01: 大字砸入 + TTS ──
  {
    sceneId: "S01",
    durationInFrames: 100,  // ~3.3s @ 30fps
    preset: "SmashText.drop",
    props: {
      mainText: "AI 视频革命",
      subText: "一个人 = 一支团队",
      highlight: ["革命"],
    },
    audio: {
      src: "audio/tts-01.mp3",
    },
  },
  // ── S02: 左右对比 + TTS ──
  {
    sceneId: "S02",
    durationInFrames: 120,  // ~4s
    preset: "SplitCompare.slideIn",
    props: {
      leftText: "传统剪辑",
      leftDesc: "手动拖拽\n反复改稿\n效率低下",
      rightText: "AI 自动化",
      rightDesc: "JSON 驱动\n一键出片\n100 倍提效",
    },
    audio: {
      src: "audio/tts-02.mp3",
    },
  },
  // ── S03: 裂开展示 + TTS ──
  {
    sceneId: "S03",
    durationInFrames: 90,   // ~3s
    preset: "SmashText.splitReveal",
    props: {
      mainText: "全 JSON 驱动",
      subText: "零代码改稿",
      highlight: ["零代码"],
    },
    audio: {
      src: "audio/tts-03.mp3",
    },
  },
];
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
